import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { Sector } from "../../types/modules/admin/sector.type";

export const useSectorsByAdmin = () => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["sectors-by-admin"],
    queryFn: () => fetcher<Sector[]>(`sector/admin`, token),
  });
};
